import AfterOfferingInstructions from './AfterOfferingInstructions';

export default AfterOfferingInstructions;
